import React, { createContext, useContext, useMemo, useState } from 'react';

type ContextType = {
  setShouldUpdateTerms: React.Dispatch<React.SetStateAction<boolean>>;
  shouldUpdateTerms: boolean;
};

const defaultContext: ContextType = {
  setShouldUpdateTerms() {},
  shouldUpdateTerms: false
};

const PricingContext = createContext<ContextType>(defaultContext);

export function PricingContextProvider({ children }) {
  const [shouldUpdateTerms, setShouldUpdateTerms] = useState(false);

  const value = useMemo<ContextType>(
    (): ContextType => ({
      setShouldUpdateTerms,
      shouldUpdateTerms
    }),
    [setShouldUpdateTerms, shouldUpdateTerms]
  );

  return (
    <PricingContext.Provider value={value}>{children}</PricingContext.Provider>
  );
}

PricingContextProvider.displayName = 'SearchContextProvider';

export function useShouldUpdateTerms(): boolean {
  return useContext(PricingContext).shouldUpdateTerms;
}

export default PricingContext;
